/* ==========================================================================
   Supplement ingredients — flip cards, "voir plus" expander, goto composition
   ========================================================================== */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.supReady) return;
    root.dataset.supReady = '1';

    /* Flip on the WHOLE card — big, easy tap target on mobile.
       The +/- buttons are kept (visual + keyboard) and bubble here.
       The "Voir l'étude" link is excluded so it opens normally. */
    root.querySelectorAll('[data-flip-card]').forEach(function (card) {
      if (!card.querySelector('.sup-ing__face--back')) return; /* nothing to reveal */
      card.addEventListener('click', function (e) {
        if (e.target.closest('.sup-ing__study')) return;
        var flipped = card.toggleAttribute('data-flipped');
        var front = card.querySelector('.sup-ing__face--front');
        var back = card.querySelector('.sup-ing__face--back');
        card.querySelectorAll('[data-flip-toggle]').forEach(function (b) {
          b.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        });
        if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
        if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      });
    });

    /* "Voir plus / Voir moins d'ingrédients" */
    var moreBtn = root.querySelector('[data-sup-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var open = moreBtn.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-extra]').forEach(function (el) { el.hidden = open; });
        moreBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var show = moreBtn.querySelector('[data-more-show]');
        var hide = moreBtn.querySelector('[data-more-hide]');
        if (show) show.hidden = !open;
        if (hide) hide.hidden = open;
      });
    }

    /* "Voir la composition" -> ask the tabs section to open the composition pane */
    var goto = root.querySelector('[data-sup-goto-composition]');
    if (goto) {
      goto.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('sup:show-tab', { detail: { pane: 'composition' } }));
      });
    }
  }

  function boot() {
    document.querySelectorAll('[id^="supplement-ingredients-"]').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
